import EmailLogContainer from './email-log.container';

export default EmailLogContainer;
